import React from "react";
import AddIcon from "../Icons/AddIcon";
const CustomerGroupCounts = () => (
  <div className="shadow-13 rounded-[9.954px] border border-D2DAE1">
    <div className="flex justify-between border-b border-D2DAE1 py-2 px-4 ">
      <span className="text-203C50 text-[17.918px] font-semibold">Customer Group</span>
      <span>
        <AddIcon />
      </span>
    </div>

    <div className="px-4">
      <div className="flex justify-between py-3">
        <label className="text-[#008937] text-sm font-medium">Data</label>
        <span className="text-[#2C495D] text-sm font-medium">45</span>
      </div>

      <div className="flex justify-between py-3">
        <label className="text-[#0E8BFE] text-sm font-medium">Customer</label>
        <span className="text-[#2C495D] text-sm font-medium">62</span>
      </div>

      <div className="flex justify-between py-3">
        <label className="text-[#F16136] text-sm font-medium">project</label>
        <span className="text-[#2C495D] text-sm font-medium">15</span>
      </div>

      <div className="flex justify-between py-3">
        <label className="text-[#EE950F] text-sm font-medium">Lead</label>
        <span className="text-[#2C495D] text-sm font-medium">20</span>
      </div>

      <div className="flex justify-between py-3">
        <label className="text-[#BC1203] text-sm font-medium">Deal</label>
        <span className="text-[#2C495D] text-sm font-medium">16</span>
      </div>
    </div>
  </div>
);

export default CustomerGroupCounts;
